import React from 'react';
import StatisticsTableRow from './StatisticsTableRow';
import SystemMonitorFormattedMessages from '../../../messages/admin/SystemMonitorFormattedMessages';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import Loader from '../../common/Loader';

const StatisticsTable = (props) => {
  /*
      Creates the Table/List to display all log data
  */
  const generateTables = () => {
    if (props.statsPageReady) {
      return (
        <div key="statsLists" className="statsTables">
          <div key="primaryQueueStatsList" className="primaryQueueStatstable">
            <Typography variant="h3" gutterBottom>
              {SystemMonitorFormattedMessages.statsTitle}
            </Typography>

            <TableContainer sx={{ marginBottom: 4, overflowX: 'auto' }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Queue Name</TableCell>
                    <TableCell>Number of messages</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>Primary Inbound</TableCell>
                    <TableCell>
                      {props.primaryQueueStats.PrimaryInbound}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Primary Outbound High</TableCell>
                    <TableCell>
                      {props.primaryQueueStats.PrimaryOutbound_H}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Primary Outbound Medium</TableCell>
                    <TableCell>
                      {props.primaryQueueStats.PrimaryOutbound_M}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Primary Outbound Low</TableCell>
                    <TableCell>
                      {props.primaryQueueStats.PrimaryOutbound_L}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          <div key="totalStatsList" className="totalStatstable">
            <Typography variant="h3" gutterBottom>
              {SystemMonitorFormattedMessages.totalStatsTitle}
            </Typography>
            <TableContainer sx={{ marginBottom: 4, overflowX: 'auto' }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>MuxId</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Protocol</TableCell>
                    <TableCell>TX_OK</TableCell>
                    <TableCell>TX_ERR</TableCell>
                    <TableCell>RX</TableCell>
                    <TableCell>Today</TableCell>
                    <TableCell>H</TableCell>
                    <TableCell>M</TableCell>
                    <TableCell>L</TableCell>
                    <TableCell>Age (s)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {generateTotalStatsTableBody(props.totalStats, false)}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          <div key="totalTwilioStatsList" className="totalTwilioStatstable">
            <Typography variant="h3" gutterBottom>
              {SystemMonitorFormattedMessages.totalTwilioStatsTitle}
            </Typography>

            <TableContainer sx={{ marginBottom: 4, overflowX: 'auto' }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>MuxId</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Protocol</TableCell>
                    <TableCell>TX_OK</TableCell>
                    <TableCell>TX_ERR</TableCell>
                    <TableCell>RX</TableCell>
                    <TableCell>Today</TableCell>
                    <TableCell>H</TableCell>
                    <TableCell>M</TableCell>
                    <TableCell>L</TableCell>
                    <TableCell>Age (s)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {generateTotalStatsTableBody(props.totalTwilioStats, true)}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      );
    } else {
      return <Loader />;
    }
  };

  /*
     Generates the body of the Table/List to display total stats / total twilio stats
   */
  const generateTotalStatsTableBody = (stats, isTwilio) => {
    let rows = [];
    for (let i = 0; i < stats.length; i++) {
      rows.push(
        <StatisticsTableRow
          key={stats[i].muxId}
          id={stats[i].muxId}
          muxId={stats[i].muxId}
          status={stats[i].status}
          protocol={stats[i].protocol}
          txOk={stats[i].txOk}
          txErr={stats[i].txErr}
          rx={stats[i].rx}
          today={stats[i].today}
          maxPerDay={stats[i].maxPerDay}
          H={stats[i].H}
          M={stats[i].M}
          L={stats[i].L}
          age={stats[i].age}
          isTwilio={isTwilio}
          onClickName={(e) => props.muxIdDrilldown(e, isTwilio)}
        />
      );
    }
    return rows;
  };

  return generateTables();
};

export default StatisticsTable;
